import { render, staticRenderFns } from "./processAccidentMainPop.vue?vue&type=template&id=37bc98bb"
import script from "./processAccidentMainPop.vue?vue&type=script&lang=js"
export * from "./processAccidentMainPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37bc98bb')) {
      api.createRecord('37bc98bb', component.options)
    } else {
      api.reload('37bc98bb', component.options)
    }
    module.hot.accept("./processAccidentMainPop.vue?vue&type=template&id=37bc98bb", function () {
      api.rerender('37bc98bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/processAccidentMainPop.vue"
export default component.exports